<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="xl" :visible="modal.show" :data="model" scrollable
                   :title="computedTitle" @show="onShow" hide-footer
                   @hidden="onHidden" @ok.prevent="onSubmit" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">

      <spinner :show="loading" height="15" spinner-size="5" font-size="1.5"
               :text="$t('Fetching data from Docusign..')"/>

      <iframe v-if="url" :src="url" :key="url" style="width: 100%;height: 45em"/>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import ContractSend from "@/modules/contracts/ContractSend.model";
  import ContractService from "@/modules/contracts/ContractService";
  import Spinner from "@/core/components/common/Spinner";

  const {mapState, mapActions} = createNamespacedHelpers('contracts');
  const {mapState: globalState} = createNamespacedHelpers('global');

  export default {
    name: "ContractSendModal",
    components: {
      Spinner,
      ArtisioModal
    },
    data() {
      return {
        model: new ContractSend(),
        showConfirmation: false,
        url: null
      }
    },
    computed: {
      ...mapState({
        modal: state => state.contractSendModal,
        editObject: state => state.contractSendModal.object,
        loading: state => state.contractSendModal.loading,
      }),
      ...globalState({
        currentBranch: state => state.currentBranch,
      }),
      computedTitle() {
        return this.$i18n.t('Send Contract')
      }
    },
    watch: {
      async editObject() {
        this.model = new ContractSend(this.editObject);

        if (this.model.uuid) {
          this.toggleSendModalLoading(true)

          let response = await ContractService.getContractPreviewURL(this.model.uuid)

          this.toggleSendModalLoading(false)

          this.hideContractSendModal()

          if (response.success) {
            window.open(response.body.url, '_blank');
            // this.url = response.body.url
          } else {
            if (response.body.non_field_errors) {
              this.$errorDialog(response.body.non_field_errors[0]);
            }
          }
        }
      },
    },
    methods: {
      ...mapActions(['hideContractSendModal', 'toggleSendModalLoading']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new ContractSend();
        this.hideContractSendModal();
        this.url = null;
      },
      async onSubmit() {
      },
    }
  }
</script>

<style scoped>

</style>
